// src/styles/Theme.js
import tokens from './tokens';

const theme = {
  colors: {
    // Full token map first, then semantic overrides (overrides win over spread)
    ...tokens.colors,
    // Legacy semantic keys — components that reference theme.colors.body, .text, etc.
    body: tokens.colors.background,
    text: tokens.colors['on-surface'],
    // 'primary' and 'secondary' keep their token values — do not override
    accent: tokens.colors['primary-container'],
    footerBackground: tokens.colors['surface-container'],
    footerText: tokens.colors['on-surface-variant'],
    link: tokens.colors.secondary,
    buttonBackground: tokens.colors.primary,
    buttonText: tokens.colors['on-primary'],
  },
  fonts: tokens.fonts,
  radii: tokens.radii,
  shadows: tokens.shadows,
  breakpoints: tokens.breakpoints,
};

export default theme;
